"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

var _core = require("@emotion/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

const StyledImage = (
/*#__PURE__*/
0, _styledBase.default)((_ref) => {
  let {
    value: src
  } = _ref;
  return (0, _core.jsx)("img", {
    src: src || '',
    role: "presentation"
  });
}, {
  target: "e1ksx8c40",
  label: "StyledImage"
})(process.env.NODE_ENV === "production" ? {
  name: "6b4u1g",
  styles: "display:block;max-width:100%;height:auto;"
} : {
  name: "6b4u1g",
  styles: "display:block;max-width:100%;height:auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JbWFnZVByZXZpZXcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTTJGIiwiZmlsZSI6Ii4uLy4uL3NyYy9JbWFnZVByZXZpZXcuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IExpc3QgfSBmcm9tICdpbW11dGFibGUnO1xuaW1wb3J0IHsgV2lkZ2V0UHJldmlld0NvbnRhaW5lciwgQXNzZXQgfSBmcm9tICduZXRsaWZ5LWNtcy11aS1kZWZhdWx0JztcblxuY29uc3QgU3R5bGVkSW1hZ2UgPSBzdHlsZWQoKHsgdmFsdWU6IHNyYyB9KSA9PiA8aW1nIHNyYz17c3JjIHx8ICcnfSByb2xlPVwicHJlc2VudGF0aW9uXCIgLz4pYFxuICBkaXNwbGF5OiBibG9jaztcbiAgbWF4LXdpZHRoOiAxMDAlO1xuICBoZWlnaHQ6IGF1dG87XG5gO1xuXG5jb25zdCBTdHlsZWRJbWFnZUFzc2V0ID0gKHsgZ2V0QXNzZXQsIHZhbHVlLCBmaWVsZCB9KSA9PiB7XG4gIHJldHVybiAoXG4gICAgPEFzc2V0XG4gICAgICBmb2xkZXI9e2ZpZWxkLmdldCgnbWVkaWFfZm9sZGVyJyl9XG4gICAgICBwYXRoPXt2YWx1ZX1cbiAgICAgIGdldEFzc2V0PXtnZXRBc3NldH1cbiAgICAgIGNvbXBvbmVudD17U3R5bGVkSW1hZ2V9XG4gICAgLz5cbiAgKTtcbn07XG5cbmNvbnN0IEltYWdlUHJldmlld0NvbnRlbnQgPSBwcm9wcyA9PiB7XG4gIGNvbnN0IHsgdmFsdWUsIGdldEFzc2V0LCBmaWVsZCB9ID0gcHJvcHM7XG4gIGlmIChBcnJheS5pc0FycmF5KHZhbHVlKSB8fCBMaXN0LmlzTGlzdCh2YWx1ZSkpIHtcbiAgICByZXR1cm4gdmFsdWUubWFwKHZhbCA9PiAoXG4gICAgICA8U3R5bGVkSW1hZ2VBc3NldCBrZXk9e3ZhbH0gdmFsdWU9e3ZhbH0gZ2V0QXNzZXQ9e2dldEFzc2V0fSBmaWVsZD17ZmllbGR9IC8+XG4gICAgKSk7XG4gIH1cbiAgcmV0dXJuIDxTdHlsZWRJbWFnZUFzc2V0IHsuLi5wcm9wc30gLz47XG59O1xuXG5jb25zdCBJbWFnZVByZXZpZXcgPSBwcm9wcyA9PiB7XG4gIHJldHVybiAoXG4gICAgPFdpZGdldFByZXZpZXdDb250YWluZXI+XG4gICAgICB7cHJvcHMudmFsdWUgPyA8SW1hZ2VQcmV2aWV3Q29udGVudCB7Li4ucHJvcHN9IC8+IDogbnVsbH1cbiAgICA8L1dpZGdldFByZXZpZXdDb250YWluZXI+XG4gICk7XG59O1xuXG5JbWFnZVByZXZpZXcucHJvcFR5cGVzID0ge1xuICBnZXRBc3NldDogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgdmFsdWU6IFByb3BUeXBlcy5ub2RlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSW1hZ2VQcmV2aWV3O1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const StyledImageAsset = (_ref2) => {
  let {
    getAsset,
    value,
    field
  } = _ref2;
  return (0, _core.jsx)(_netlifyCmsUiDefault.Asset, {
    folder: field.get('media_folder'),
    path: value,
    getAsset: getAsset,
    component: StyledImage
  });
};

const ImagePreviewContent = props => {
  const {
    value,
    getAsset,
    field
  } = props;

  if (Array.isArray(value) || _immutable.List.isList(value)) {
    return value.map(val => (0, _core.jsx)(StyledImageAsset, {
      key: val,
      value: val,
      getAsset: getAsset,
      field: field
    }));
  }

  return (0, _core.jsx)(StyledImageAsset, props);
};

const ImagePreview = props => {
  return (0, _core.jsx)(_netlifyCmsUiDefault.WidgetPreviewContainer, null, props.value ? (0, _core.jsx)(ImagePreviewContent, props) : null);
};

ImagePreview.propTypes = {
  getAsset: _propTypes.default.func.isRequired,
  value: _propTypes.default.node
};
var _default = ImagePreview;
exports.default = _default;